export const HINT_NUMBER = 0;
